









import {WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {bus} from "@/main"
import {defineComponent} from "@vue/composition-api"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Text(),
    widget: "PMJobsRaisedInAMonth",
    title: "PPM jobs raised for month to date",
    _description: "",
    params: {
      hdCategory: {...WParamTpl.hdCategory(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const p = extractParams(params)
  return {
    value: formatNumberWithGrouping((await executeQuery(
      "FMS_DB",
      "jobsRaised",
      {ppmRepair: 1, category: p.category, year: p.year, month: p.month, day: 0}))[0].Value),
  }
}

async function titleCallback(config: any) {
  return getTitle(config.params)
}

export default defineComponent({
  props: {config: {type: Object, required: true}},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      bus.$emit("chartPopup", {
        title: config().title,
        component: () => import("@/components/drilldowns/JobsRaisedPPMDrillDown.vue"),
        componentArgs: {...extractParams(props.config.params), day: 0, hdPPMRepairAll: 1},
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
